import {Enum} from "~/enums/index";

export default new Enum({
    ACCEPT: "ACCEPT",
    REJECT: "REJECT",
    UNDECIDED: "UNDECIDED",
});
